import React from 'react';
import { SearchIcon, ShieldIcon, ClipboardCheckIcon } from 'lucide-react';
export function Offer() {
  return <section id="angebot" className="py-16 bg-white" data-id="element-372">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-373">
        <div className="text-center" data-id="element-374">
          <h2 className="text-3xl font-extrabold text-gray-900 sm:text-4xl" data-id="element-375">
            Unser Angebot
          </h2>
          <p className="mt-4 text-lg text-gray-600 max-w-3xl mx-auto" data-id="element-376">
            Das §390 Readiness-Paket für Ihre Praxis
          </p>
        </div>
        <div className="mt-12" data-id="element-377">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-4 md:gap-8" data-id="element-378">
            {/* Schritt 1 */}
            <div className="mt-4 md:mt-0" data-id="element-379">
              <div className="relative" data-id="element-380">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-381">
                  1
                </div>
                <div className="pl-20" data-id="element-382">
                  <div className="flex items-center" data-id="element-383">
                    <SearchIcon className="h-6 w-6 text-blue-600" data-id="element-384" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-385">
                      Analyse & Audit
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-386">
                <ul className="space-y-4 flex-grow" data-id="element-387">
                  <li className="flex items-start" data-id="element-388">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-389">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-390"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-391">
                      Prüfung aller Sicherheitsmaßnahmen (Personal, IT,
                      Prozesse)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-392">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-393">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-394"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-395">
                      Bestandsaufnahme vorhandener Hard- und Software
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-396">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-397">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-398"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-399">
                      Überprüfung der aktuellen IT-Sicherheitsmaßnahmen
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-400">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-401">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-402"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-403">
                      Erstellung eines Maßnahmenplans mit Ampelstatus
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Schritt 2 */}
            <div className="mt-4 md:mt-0" data-id="element-404">
              <div className="relative" data-id="element-405">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-406">
                  2
                </div>
                <div className="pl-20" data-id="element-407">
                  <div className="flex items-center" data-id="element-408">
                    <ShieldIcon className="h-6 w-6 text-blue-600" data-id="element-409" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-410">
                      Umsetzung & Härtung
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-411">
                <ul className="space-y-4 flex-grow" data-id="element-412">
                  <li className="flex items-start" data-id="element-413">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-414">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-415"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-416">
                      Einrichtung von Backup- und Update-Management
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-417">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-418">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-419"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-420">
                      Schulung der Mitarbeitenden zu IT-Sicherheitsthemen
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-421">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-422">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-423"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-424">
                      Absicherung der E-Mail-Kommunikation und Netzwerke
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-425">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-426">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-427"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-428">
                      Cloud-Anbieterprüfung und Netzwerksegmentierung
                    </p>
                  </li>
                </ul>
              </div>
            </div>
            {/* Schritt 3 */}
            <div className="mt-4 md:mt-0" data-id="element-429">
              <div className="relative" data-id="element-430">
                <div className="absolute flex items-center justify-center h-16 w-16 rounded-md bg-blue-600 text-white text-2xl font-bold" data-id="element-431">
                  3
                </div>
                <div className="pl-20" data-id="element-432">
                  <div className="flex items-center" data-id="element-433">
                    <ClipboardCheckIcon className="h-6 w-6 text-blue-600" data-id="element-434" />
                    <h3 className="ml-2 text-xl font-medium text-gray-900" data-id="element-435">
                      Doku & Nachweis
                    </h3>
                  </div>
                </div>
              </div>
              <div className="mt-6 bg-blue-50 rounded-lg p-6 h-[400px] flex flex-col" data-id="element-436">
                <ul className="space-y-4 flex-grow" data-id="element-437">
                  <li className="flex items-start" data-id="element-438">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-439">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-440"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-441">
                      Alle Anforderungen der KBV werden nachvollziehbar
                      dokumentiert
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-442">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-443">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-444"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-445">
                      Sie erhalten ein „Readiness-Zertifikat" (optional)
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-446">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-447">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-448"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-449">
                      Erstellung von Prozessdokumentationen und Richtlinien
                    </p>
                  </li>
                  <li className="flex items-start" data-id="element-450">
                    <svg className="h-5 w-5 text-blue-500 mt-1" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-451">
                      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-452"></path>
                    </svg>
                    <p className="ml-3 text-gray-700" data-id="element-453">
                      Unterstützung bei jährlicher Nachprüfung
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
        </div>
        <div className="mt-16 bg-blue-50 rounded-lg p-8 shadow-sm" data-id="element-454">
          <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-455">
            Ihre Vorteile auf einen Blick
          </h3>
          <div className="grid md:grid-cols-2 gap-6" data-id="element-456">
            <div className="flex items-start" data-id="element-457">
              <div className="flex-shrink-0" data-id="element-458">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-459">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-460">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-461"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-462">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-463">
                  Rechtssicherheit
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-464">
                  Erfüllung aller gesetzlichen Anforderungen gemäß §390 SGB V
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-465">
              <div className="flex-shrink-0" data-id="element-466">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-467">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-468">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-469"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-470">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-471">
                  Zeitersparnis
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-472">
                  Wir übernehmen die komplette Umsetzung – Sie können sich auf
                  Ihre Patienten konzentrieren
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-473">
              <div className="flex-shrink-0" data-id="element-474">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-475">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-476">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-477"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-478">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-479">
                  Expertenwissen
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-480">
                  Profitieren Sie von unserer langjährigen Erfahrung im Bereich
                  IT-Sicherheit für Arztpraxen
                </p>
              </div>
            </div>
            <div className="flex items-start" data-id="element-481">
              <div className="flex-shrink-0" data-id="element-482">
                <div className="flex items-center justify-center h-10 w-10 rounded-md bg-blue-600 text-white" data-id="element-483">
                  <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24" data-id="element-484">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" data-id="element-485"></path>
                  </svg>
                </div>
              </div>
              <div className="ml-4" data-id="element-486">
                <h4 className="text-lg font-medium text-gray-900" data-id="element-487">
                  Nachhaltiger Schutz
                </h4>
                <p className="mt-2 text-gray-600" data-id="element-488">
                  Langfristige Absicherung Ihrer Praxis durch regelmäßige
                  Überprüfungen und Updates
                </p>
              </div>
            </div>
          </div>
          <div className="mt-8 text-center" data-id="element-489">
            <a href="#kontakt" className="inline-flex items-center justify-center px-6 py-3 border border-transparent text-base font-medium rounded-md shadow-sm text-white bg-blue-600 hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500" data-id="element-490">
              Jetzt unverbindlich beraten lassen
            </a>
          </div>
        </div>
      </div>
    </section>;
}